import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { controlIcons } from './control-icons';
import { controlTypes } from './control-types';
import { themeTypes } from './theme-types';
import { modeTypes } from './mode-types';
import LiveArrowControlStrategy from './live-arrow-control-strategy';

const LiveArrowControl = (props) => {
    const themeCss = classNames({
        'is-light': props.theme === themeTypes.light
    });

    const chooseStrategy = (mode) => {
        if (mode === modeTypes.hole) {
            LiveArrowControlStrategy.hole(props.holeId, props.type, props.holesLength, props.renderHole);
        }

        if (mode === modeTypes.carousel) {
            LiveArrowControlStrategy.carousel(props.type, props.onClickPrevBtn, props.onClickNextBtn);
        }

        return false;
    };

    return (
        <button
            className={`live-arrow-control ${themeCss}`}
            type="button"
            onClick={() => chooseStrategy(props.mode)}
        >
            <svg className="live-arrow-control__icon icon" width="14" height="14" focusable="false">
                <use
                    xlinkHref={`#icon-${props.type === controlTypes.next ? controlIcons.chevronRight : controlIcons.chevronLeft}`}></use>
            </svg>
        </button>
    );
};

LiveArrowControl.propTypes = {
    mode: PropTypes.string,
    theme: PropTypes.string,
    holeId: PropTypes.number,
    holesLength: PropTypes.number,
    type: PropTypes.string,
    renderHole: PropTypes.func,
    onClickPrevBtn: PropTypes.func,
    onClickNextBtn: PropTypes.func
};

export default LiveArrowControl;
